import {Injectable} from "@angular/core";
import {GetCartDetailUseCase} from "@app/core/cart/application/get-cart-detail.use-case";
import {CartQuantityNotifier} from "@app/core/cart/domain/cart-quantity-notifier";
import {CartDetail} from "@app/core/cart/domain/dtos/cart-detail";
import {
    GetSimilarProductsOfProductsUseCase
} from "@app/core/product/application/get-similar-products-of-products.use-case";
import {BehaviorSubject, Observable} from "rxjs";
import {map, share, switchMap} from "rxjs/operators";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {IsLoggedInUseCase} from "@app/core/user/application/isLoggedIn.use-case";
import {GetPromotionListUseCase} from "@app/core/promotion/application/get-promotion-list.use-case";
import {Promotion} from "@app/core/promotion/domain/dtos/promotion";

@Injectable()
export class CartDetailViewModel {

    notifier = new PopupNotifier();

    readonly cartQuantity$ = this.cartQuantityNotifier.cartQuantity$;

    readonly cartDetail$: Observable<CartDetail> = this.cartQuantity$.pipe(
        switchMap(() => this.getCartDetailUseCase.execute().pipe(share())),
        onError(error => this.notifier.notifyError(error)),
    );

    readonly isLoggedIn$ = this.isLoggedInUseCase.execute();

    private productCodes$: Observable<string[]> = this.cartDetail$.pipe(
        map(cartDetail => cartDetail.lines),
        map(cartLines => cartLines.map(cartLine => cartLine.code))
    );
    readonly similarProducts$ = this.productCodes$.pipe(
        switchMap(productCodes => this.getSimilarProductsOfProductsUseCase.execute(productCodes, 3, 1)),
        onError(error => this.notifier.notifyError(error)),
    )

    private promotionsSubject = new BehaviorSubject<Promotion[]>([]);
    readonly promotions$ = this.promotionsSubject.asObservable();

    constructor(
        private getCartDetailUseCase: GetCartDetailUseCase,
        private cartQuantityNotifier: CartQuantityNotifier,
        private getSimilarProductsOfProductsUseCase: GetSimilarProductsOfProductsUseCase,
        private isLoggedInUseCase: IsLoggedInUseCase,
        private getPromotionListUseCase: GetPromotionListUseCase,
    ) {
        this.loadPromotions();
    }

    private loadPromotions(): void {
        this.getPromotionListUseCase.execute(0,1).subscribe({
            next: promotions => this.promotionsSubject.next(promotions.promo),
            error: error => this.notifier.notifyError(error),
        });
    }



}
